export default __webpack_public_path__ + "static/media/icon-select-orange.ac908edb.svg";